import { useEffect, useMemo, useRef, useState } from "react";

// Third-party libraries
import _, { isEmpty } from "lodash";
import { DateTime } from "luxon";
import moment from "moment";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { getAllDeptDivsionAndApp, getMainFilterApi } from "../CommonFilter/complainceFilterSlice.js";

//Slice
import {
  getProjectList,
  getSprintList,
} from "../../../DevopsInsights/observabilitySlice.js";

// Components
import ButtonComponent from "../ButtonComponent.jsx";
import CustomDateRangePicker from "../DateRangePicker/DateRangePicker.jsx";
import CustomSelect from "../select/index.jsx";

// Helpers & Constants
import {
  formatDateWithServerZone,
  getDefaultSelectedDate,
  serverZone,
} from "../../utilities/dateUtils.js";
import { useCommonAlert } from "../../utilities/helpers.js";
import { clearedFilters } from "./constants.js";
import { getActiveDateAppCodes, normalizeMainFilterResponse } from "./helper.js";

// Styles
import "./filters.styles.scss";

const dedupeByValue = (list) =>
  _.uniqBy(list, (item) => item.value);

const DevOpsFilter = (props) => {
  const {
    filterOptions,
    getFilteredData,
    isNavigated,
    FilterDisable,
    isDI,

    // Project and Sprint dropdowns
    hideProjectDropdown,
    hideSprintDropdown,
    projectFilterUrl,

    // UI Styles and Classes
    flowFilterClass,
    inputStyle,
    dateInputStyle,
    hideDateRangePickerClass,

    // More Filter Options
    MoreTypeFilterClick,
    MoreFilterText,
    enableMoreFiler,
    setEnableMoreFilter,
  } = props;

  console.log(isDI);

  const dispatch = useDispatch();

  const { userName, userRole } = useSelector(
    (state) => state.common.loggedUser
  );
  const { initialStartDate, initialEndDate } = getDefaultSelectedDate();
  const { DepartmentDivisionOption: rawDeptDivOption, mainFilterApiData } = useSelector((state) => state.filterApi);
  const DepartmentDivisionOption = useMemo(
    () => isDI ? rawDeptDivOption : normalizeMainFilterResponse(mainFilterApiData || []),
    [isDI, rawDeptDivOption, mainFilterApiData]
  );
  const { projectList, sprintList } = useSelector(
    (state) => state.observability
  ) ?? [];
  const selectedApplicationHome = useSelector(
    (state) => state.Homedata?.homeSelectedApp
  ) ?? [];


  //////navigate Application
  const isExpectedFormat =
    !/\[.*?\]/.test(selectedApplicationHome.label) &&
    !selectedApplicationHome.id;
  const homeSelectedApplication = isExpectedFormat
    ? selectedApplicationHome
    : [
      {
        label: selectedApplicationHome.label.replace(/\[.*?\]/g, "").trim(),
        value: selectedApplicationHome.value,
      },
    ];

  //// Alert import
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  const callAlert = (type, msg) => {
    callCommonAlert(type, msg);
    hideCommonAlert();
  };

  // Sprint handle state
  const [IsSprintSelect, setIsSprintSelect] = useState(false);

  const initialDateSettings = {
    timePicker: false,
    maxDate: moment().toDate(),
    autoApply: true,
    startDate: initialStartDate.toMillis(),
    endDate: initialEndDate.toMillis(),
    locale: {
      format: "DD/MM/YYYY",
    },
  };
  const setSelectedDate = (date) => {
    const selectedDate = formatDateWithServerZone(date);

    onFilterChange(selectedDate, "date", "selectedDate");
  };

  const [state, setState] = useState({
    applOptions: [],
    projOptions: [],
    sprintOptions: [],
    departmentOptions: [],
    divisionOptions: [],
  });

  // Store the full initial options loaded on mount so they can be
  // reliably restored when the user clears a filter selection.
  const allInitialOptionsRef = useRef({
    applOptions: [],
    projOptions: [],
    departmentOptions: [],
    divisionOptions: [],
  });

  const [selectedFilters, setSelectedFilter] = useState({
    selectedApplication: [],
    selectedProject: [],
    selectedSprint: [],
    selectedDepartment: [],
    selectedDivision: [],
    selectedDate: initialDateSettings,
  });
  useEffect(() => {
    if (userName !== "" && userRole !== "" && !isNavigated) {
      setState((prevState) => ({
        ...prevState,
        applOptions: [],
        projOptions: [],
      }));
      const filterApiAction = isDI ? getAllDeptDivsionAndApp() : getMainFilterApi();
      dispatch(filterApiAction).then((data) => {
        const responseData = isDI ? data.payload : normalizeMainFilterResponse(data.payload);
        const AppList = dedupeByValue(
          (responseData || [])
            .flatMap((item) => item.divisions)
            .flatMap((div) =>
              div.applications.map((app) => ({
                label: app.appName,
                value: app.appCode,
              }))
            )
        );

        const DepList = (responseData || []).map((item) => ({
          label: item.businessDepartment,
          value: item.businessDepartment,
        }));
        const DivList = (responseData || []).flatMap((item) =>
          (item.divisions || []).map((div) => ({
            label: div.businessDivision,
            value: div.businessDivision,
          }))
        );

        // Save the full initial options for reliable restore on filter clear
        allInitialOptionsRef.current = {
          applOptions: AppList,
          departmentOptions: DepList,
          divisionOptions: DivList,
        };

        // Set applOptions immediately so dropdown options are available
        setState((prevState) => ({
          ...prevState,
          applOptions: AppList,
          departmentOptions: DepList,
          divisionOptions: DivList,
        }));

        const projectListPayload = {
          appCodes: _.map([AppList[0]], (app) => app.value),
          projects: [],
          sprint: [],
        };
        setSelectedFilter((prevFilters) => ({
          ...prevFilters,
          selectedApplication: [AppList[0]],
        }));

        dispatch(
          getProjectList({ payload: projectListPayload, url: projectFilterUrl })
        )
          .unwrap()
          .then((projectList) => {
            const projList = (projectList || []).map((list) => ({
              label: list.projectName,
              value: list.projectName,
            }));
            setState((prevState) => ({
              ...prevState,
              projOptions: projList,
            }));
            return projList; // Return for chaining
          })
          .catch((error) => {
            console.error("Failed to fetch projects:", error);
            setState((prevState) => ({
              ...prevState,
              projOptions: [],
            }));
            return []; // Return empty array to continue chain
          })
          .then((projList) => {
            const sprintListPayload = {
              appCodes: _.map([AppList[0]], (app) => app.value),
              projects: _.map(projList, (proj) => proj.value),
              sprintName: [],
              startDt: _.get(selectedFilters, "selectedDate.startDate", ""),
              toDt: _.get(selectedFilters, "selectedDate.endDate", ""),
            };

            const filterUpdate = {
              selectedProject: projList,
              selectedApplication: [AppList[0]],
              selectedDepartment: [],
              selectedDivision: [],
              selectedDate: initialDateSettings,
              shouldApplyFilter: true,
            };

            handleSprintData(sprintListPayload, filterUpdate);
          });
      });
    }
  }, []);

  const InitialFilterUpdate = (DepartmentDivisionOption) => {
    const appList = dedupeByValue(
      DepartmentDivisionOption.flatMap(
        (item) => item.divisions
      ).flatMap((div) =>
        div.applications.map((app) => ({
          label: app.appName,
          value: app.appCode,
        }))
      )
    );

    const DepList = DepartmentDivisionOption.map((item) => ({
      label: item.businessDepartment,
      value: item.businessDepartment,
    }));
    const DivList = DepartmentDivisionOption.flatMap((item) =>
      item.divisions.map((div) => ({
        label: div.businessDivision,
        value: div.businessDivision,
      }))
    );
    setState((prevState) => ({
      ...prevState,
      applOptions: appList,
      departmentOptions: DepList,
      divisionOptions: DivList,
    }));
  };

  const handleSprintData = (sprintListPayload, filterUpdate) => {
    if (!hideSprintDropdown) {
      dispatch(getSprintList(sprintListPayload)).then((data) => {
        const SprintList = _.map(data.payload, (val) => ({
          label: val,
          value: val,
        }));

        setState((prevState) => ({
          ...prevState,
          sprintOptions: SprintList,
        }));

        const filterWithSprint = {
          ...filterUpdate,
          selectedSprint: SprintList,
        };

        setSelectedFilter((prevFilters) => ({
          ...prevFilters,
          ...filterWithSprint,
        }));

        if (filterUpdate.shouldApplyFilter) {
          onFilterClick(filterWithSprint);
        }
      });
    } else {
      const filterWithoutSprint = {
        ...filterUpdate,
        selectedSprint: [],
      };

      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        ...filterWithoutSprint,
      }));

      if (filterUpdate.shouldApplyFilter) {
        onFilterClick(filterWithoutSprint);
      }
    }
  };

  useEffect(() => {
    if (isNavigated) {
      const navigatedFilterAction = isDI ? getAllDeptDivsionAndApp() : getMainFilterApi();
      dispatch(navigatedFilterAction).then((data) => {
        const responseData = isDI ? data.payload : normalizeMainFilterResponse(data.payload);
        InitialFilterUpdate(responseData);
      });
      const projectListPayload = {
        appCodes: _.map(homeSelectedApplication, (app) => app.value),
        projects: [],
        sprint: [],
      };
      // Ensure selectedApplication is always an array
      const safeApplicationSelection = Array.isArray(homeSelectedApplication)
        ? homeSelectedApplication
        : [homeSelectedApplication].filter(Boolean);
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedApplication: safeApplicationSelection,
      }));
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedApplication: safeApplicationSelection,
      }));
      dispatch(
        getProjectList({ payload: projectListPayload, url: projectFilterUrl })
      )
        .unwrap()
        .then((projectList) => {
          const projList = (projectList || []).map((list) => ({
            label: list.projectName,
            value: list.projectName,
          }));

          setState((prevState) => ({
            ...prevState,
            applOptions: safeApplicationSelection,
            projOptions: projList,
          }));
          return projList;
        })
        .catch((error) => {
          console.error("Failed to fetch projects:", error);
          setState((prevState) => ({
            ...prevState,
            projOptions: [],
          }));
          return [];
        })
        .then((projList) => {
          const sprintListPayload = {
            appCodes: _.map(homeSelectedApplication, (app) => app.value),
            projects: _.map(projList, (proj) => proj.value),
            sprintName: [],
            startDt: _.get(selectedFilters, "selectedDate.startDate", ""),
            toDt: _.get(selectedFilters, "selectedDate.endDate", ""),
          };

          const filterUpdate = {
            selectedProject: projList,
            selectedApplication: homeSelectedApplication,
            selectedDepartment: [],
            selectedDivision: [],
            selectedDate: initialDateSettings,
            shouldApplyFilter: true,
          };

          handleSprintData(sprintListPayload, filterUpdate);
        });
    }
  }, [isNavigated]);

  useEffect(() => {
    InitialFilterUpdate(DepartmentDivisionOption);
  }, [DepartmentDivisionOption]);

  useEffect(() => {
    if (!_.isEmpty(projectList)) {
      const projList = projectList.map((list) => {
        return {
          label: list.projectName,
          value: list.projectName,
        };
      });
      setState((prevState) => ({
        ...prevState,
        projOptions: projList,
      }));
    }
  }, [projectList]);

  useEffect(() => {
    if (!_.isEmpty(sprintList)) {
      const sprintOpts = _.map(sprintList, (val) => {
        return {
          label: val,
          value: val,
        };
      });
      setState((prevState) => ({
        ...prevState,
        sprintOptions: sprintOpts,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        sprintOptions: [],
      }));
    }
  }, [sprintList]);

  const onFilterChange = (selectedFilter, type, key) => {
    setIsSprintSelect(false);

    if (type === "department") {
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedApplication: [],
        selectedProject: [],
        selectedSprint: [],
        selectedDivision: [],
      }));
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedDepartment: selectedFilter,
      }));

      if (isEmpty(selectedFilter)) {
        InitialFilterUpdate(DepartmentDivisionOption);
        setState((prevState) => ({
          ...prevState,
          projOptions: [],
          sprintOptions: [],
        }));
      } else {
        const filteredDivisions = DepartmentDivisionOption.filter(
          (department) =>
            selectedFilter.some(
              (filter) => filter.value === department.businessDepartment
            )
        );
        const businessDivisionOptions = filteredDivisions.flatMap(
          (department) =>
            department.divisions.map((division) => ({
              label: division.businessDivision,
              value: division.businessDivision,
            }))
        );
        const appNameOptions = dedupeByValue(
          filteredDivisions.flatMap((department) =>
            department.divisions.flatMap((division) =>
              division.applications.map((app) => ({
                label: app.appName,
                value: app.appCode,
              }))
            )
          )
        );
        setState((prevState) => ({
          ...prevState,
          applOptions: appNameOptions,
          divisionOptions: businessDivisionOptions,
        }));
        const projectListPayload = {
          appCodes: _.map(appNameOptions, (app) => app.value),
          projects: [],
          sprint: [],
        };

        dispatch(
          getProjectList({ payload: projectListPayload, url: projectFilterUrl })
        )
          .unwrap()
          .then((projectList) => {
            const projList = (projectList).map((list) => ({
              label: list.projectName,
              value: list.projectName,
            }));
            setState((prevState) => ({
              ...prevState,
              projOptions: projList,
            }));
            return projList;
          })
          .catch((error) => {
            console.error("Failed to fetch projects:", error);
            setState((prevState) => ({
              ...prevState,
              projOptions: [],
            }));
            return [];
          })
          .then((projList) => {
            const sprintListPayload = {
              appCodes: _.map(appNameOptions, (app) => app.value),
              projects: _.map(projList, (proj) => proj.value),
              sprintName: [],
              startDt:
                type == "date"
                  ? _.get(selectedFilter, "startDate")
                  : _.get(selectedFilters, "selectedDate.startDate", ""),
              toDt:
                type == "date"
                  ? _.get(selectedFilter, "endDate")
                  : _.get(selectedFilters, "selectedDate.endDate", ""),
            };
            dispatch(getSprintList(sprintListPayload)).then((data) => {
              const SprintList = _.map(data.payload, (val) => {
                return {
                  label: val,
                  value: val,
                };
              });
              setState((prevState) => ({
                ...prevState,
                sprintOptions: SprintList,
              }));
            });
          });
      }
    }
    if (type === "division") {
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedApplication: [],
        selectedProject: [],
        selectedSprint: [],
      }));
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedDivision: selectedFilter,
      }));

      if (isEmpty(selectedFilter)) {
        InitialFilterUpdate(DepartmentDivisionOption);
      } else {
        const appNameOptions = dedupeByValue(
          DepartmentDivisionOption.flatMap(
            (item) => item.divisions
          )
            .filter((div) =>
              selectedFilter.some(
                (filter) => filter.value === div.businessDivision
              )
            )
            .flatMap((div) =>
              div.applications.map((app) => ({
                label: app.appName,
                value: app.appCode,
            }))
          )
        );
        setState((prevState) => ({
          ...prevState,
          applOptions: appNameOptions,
        }));
        const projectListPayload = {
          appCodes: _.map(appNameOptions, (app) => app.value),
          projects: [],
          sprint: [],
        };

        dispatch(
          getProjectList({ payload: projectListPayload, url: projectFilterUrl })
        )
          .unwrap()
          .then((projectList) => {
            const projList = (projectList).map((list) => ({
              label: list.projectName,
              value: list.projectName,
            }));
            setState((prevState) => ({
              ...prevState,
              projOptions: projList,
            }));
            return projList;
          })
          .catch((error) => {
            console.error("Failed to fetch projects:", error);
            setState((prevState) => ({
              ...prevState,
              projOptions: [],
            }));
            return [];
          })
          .then((projList) => {
            const sprintListPayload = {
              appCodes: _.map(appNameOptions, (app) => app.value),
              projects: _.map(projList, (proj) => proj.value),
              sprintName: [],
              startDt:
                type == "date"
                  ? _.get(selectedFilter, "startDate")
                  : _.get(selectedFilters, "selectedDate.startDate", ""),
              toDt:
                type == "date"
                  ? _.get(selectedFilter, "endDate")
                  : _.get(selectedFilters, "selectedDate.endDate", ""),
            };

            const filterUpdate = {
              shouldApplyFilter: false, // Just update state, don't apply filter
            };

            handleSprintData(sprintListPayload, filterUpdate);
          });
      }
    }
    if (type === "application") {
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedProject: [],
        selectedSprint: [],
      }));
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedApplication: selectedFilter,
      }));

      // When no app is selected, restore all options from the ref
      // and use all app codes to fetch all projects
      const appCodesForProject = isEmpty(selectedFilter)
        ? allInitialOptionsRef.current.applOptions
        : selectedFilter;

      if (isEmpty(selectedFilter)) {
        setState((prevState) => ({
          ...prevState,
          ...allInitialOptionsRef.current,
        }));
      }

      const projectListPayload = {
        appCodes: _.map(appCodesForProject, (app) => app.value),
        projects: [],
        sprint: [],
      };

      dispatch(
        getProjectList({ payload: projectListPayload, url: projectFilterUrl })
      )
        .unwrap()
        .then((projectList) => {
          const projList = (projectList || []).map((list) => ({
            label: list.projectName,
            value: list.projectName,
          }));
          setState((prevState) => ({
            ...prevState,
            projOptions: projList,
          }));
          return projList;
        })
        .catch((error) => {
          console.error("Failed to fetch projects:", error);
          setState((prevState) => ({
            ...prevState,
            projOptions: [],
          }));
          return [];
        })
        .then((projList) => {
          const sprintListPayload = {
            appCodes: _.map(appCodesForProject, (app) => app.value),
            projects: _.map(projList, (proj) => proj.value),
            sprintName: [],
            startDt:
              type == "date"
                ? _.get(selectedFilter, "startDate")
                : _.get(selectedFilters, "selectedDate.startDate", ""),
            toDt:
              type == "date"
                ? _.get(selectedFilter, "endDate")
                : _.get(selectedFilters, "selectedDate.endDate", ""),
          };

          const filterUpdate = {
            shouldApplyFilter: false,
          };

          handleSprintData(sprintListPayload, filterUpdate);
        });
    }
    if (type === "project") {
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedSprint: [],
      }));
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedProject: selectedFilter,
      }));

      if (isEmpty(selectedFilter)) {
        setSelectedFilter((prevFilters) => ({
          ...prevFilters,
          selectedSprint: [],
        }));
        if (!hideSprintDropdown) {
          setIsSprintSelect(true);
          callAlert(
            "warning",
            "Please select a project first to view available sprints."
          );
        }
      }
      if (selectedFilter.length > 0) {
        const sprintListPayload = {
          appCodes: _.map(selectedFilter, (app) => app.value),
          projects: _.map(selectedFilter, (proj) => proj.value),
          sprintName: [],
          startDt:
            type == "date"
              ? _.get(selectedFilter, "startDate")
              : _.get(selectedFilters, "selectedDate.startDate", ""),
          toDt:
            type == "date"
              ? _.get(selectedFilter, "endDate")
              : _.get(selectedFilters, "selectedDate.endDate", ""),
        };

        const filterUpdate = {
          shouldApplyFilter: false,
        };

        handleSprintData(sprintListPayload, filterUpdate);
      }
    }
    if (type === "sprint") {
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        selectedSprint: selectedFilter,
      }));
    }
    if (type === "date") {
      const appCodes = getActiveDateAppCodes(
        selectedFilters,
        DepartmentDivisionOption
      );
      setSelectedFilter((prevFilters) => ({
        ...prevFilters,
        [key]: selectedFilter,
        selectedSprint: [],
      }));
      const projectListPayload = {
        appCodes: _.map(appCodes, (app) => app.value),
        projects: [],
        sprint: [],
      };

      dispatch(
        getProjectList({ payload: projectListPayload, url: projectFilterUrl })
      )
        .unwrap()
        .then((projectList) => {
          const projList = (projectList).map((list) => ({
            label: list.projectName,
            value: list.projectName,
          }));
          setState((prevState) => ({
            ...prevState,
            projOptions: projList,
          }));
          return projList;
        })
        .catch((error) => {
          console.error("Failed to fetch projects:", error);
          setState((prevState) => ({
            ...prevState,
            projOptions: [],
          }));
          return [];
        })
        .then((projList) => {
          const sprintListPayload = {
            appCodes: appCodes ? _.map(appCodes, (app) => app.value) : [],
            projects: _.map(projList, (proj) => proj.value),
            sprintName: [],
            startDt:
              type == "date"
                ? _.get(selectedFilter, "startDate")
                : _.get(selectedFilters, "selectedDate.startDate", ""),
            toDt:
              type == "date"
                ? _.get(selectedFilter, "endDate")
                : _.get(selectedFilters, "selectedDate.endDate", ""),
          };

          const filterUpdate = {
            shouldApplyFilter: false,
          };

          handleSprintData(sprintListPayload, filterUpdate);
        });
    }
  };

  //Filter APPLy
  const getSelectedData = (data) => {
    if (
      [
        data.selectedDivision,
        data.selectedSprint,
        data.selectedProject,
        data.selectedApplication,
      ].every((arr) => arr.length === 0) &&
      !isEmpty(data?.selectedDepartment)
    ) {
      const updatedData = {
        ...data,
        selectedApplication: state?.applOptions,
        selectedProject: state?.projOptions,
        selectedSprint: state?.sprintOptions,
        selectedDivision: state?.divisionOptions,
      };

      setSelectedFilter((prev) => ({ ...prev, ...updatedData }));
      return updatedData;
    }
    if (
      [
        data.selectedSprint,
        data.selectedProject,
        data.selectedApplication,
      ].every((arr) => arr.length === 0) &&
      !isEmpty(data?.selectedDivision)
    ) {
      const updatedData = {
        ...data,
        selectedApplication: state?.applOptions,
        selectedProject: state?.projOptions,
        selectedSprint: state?.sprintOptions,
      };

      setSelectedFilter((prev) => ({ ...prev, ...updatedData }));
      return updatedData;
    }
    if (
      [data.selectedSprint, data.selectedProject].every(
        (arr) => arr.length === 0
      ) &&
      !isEmpty(data?.selectedApplication)
    ) {
      const updatedData = {
        ...data,
        selectedProject: state?.projOptions,
        selectedSprint: state?.sprintOptions,
      };

      setSelectedFilter((prev) => ({ ...prev, ...updatedData }));
      return updatedData;
    }
    if (
      [data.selectedSprint].every((arr) => arr.length === 0) &&
      !isEmpty(data?.selectedProject)
    ) {
      const updatedData = {
        ...data,
        selectedSprint: state?.sprintOptions,
      };

      setSelectedFilter((prev) => ({ ...prev, ...updatedData }));
      return updatedData;
    }
    return data;
  };
  const onFilterClick = (data) => {
    const selectedFilters = getSelectedData(data);
    if (selectedFilters) {
      getFilteredData && getFilteredData(selectedFilters);
    }
    setEnableMoreFilter && setEnableMoreFilter(true);
  };
  ////initial Load

  ////

  const isFilterDisabled = Object.entries(selectedFilters).every(
    ([key, value]) =>
      key === "selectedDate" || (Array.isArray(value) && value.length === 0)
  );
  const MoreTypeFilter = () => {
    getFilteredData && MoreTypeFilterClick(selectedFilters);
  };

  const onClear = () => {
    setSelectedFilter({
      ...clearedFilters,
      selectedDate: {
        ...initialDateSettings,
        startDate: initialStartDate.toMillis(),
        endDate: initialEndDate.toMillis(),
      },
    });
    // Reset the options to initial state
    InitialFilterUpdate(DepartmentDivisionOption);
  };

  const isCancelDisabled = Object.entries(selectedFilters).every(
    ([key, value]) =>
      (Array.isArray(value) && value.length === 0) ||
      (key === "selectedDate" &&
        value.startDate === initialDateSettings.startDate &&
        value.endDate === initialDateSettings.endDate)
  );

  return (
    <>
      <div className="devops-filter-container">
        <div className="filters-wrapper">
          {filterOptions.map((filter) => {
            if (filter.type === "date") {
              return (
                <div className="filter-item date-range-filter" key={filter.key}>
                  <CustomDateRangePicker
                    initialSettings={{
                      startDate: selectedFilters.selectedDate.startDate,
                      endDate: selectedFilters.selectedDate.endDate,
                      autoApply: true,
                      maxDate: moment(
                        DateTime.now().setZone(serverZone).toJSDate()
                      ), // Luxon → moment
                      locale: {
                        format: "DD/MM/YYYY",
                      },
                    }}
                    showIcon={true}
                    className={dateInputStyle}
                    selectedDate={setSelectedDate}
                  />
                </div>
              );
            }

            if (
              (hideSprintDropdown && filter.type === "sprint") ||
              (hideProjectDropdown && filter.type === "project")
            ) {
              return (
                <div className="filter-item hidden" key={filter.key}></div>
              );
            }

            return (
              <div className="filter-item select-filter" key={filter.key}>
                <CustomSelect
                  isMulti={true}
                  withSelectAll={
                    !(
                      filter.type === "sprint" &&
                      selectedFilters["selectedProject"]?.length === 0
                    )
                  }
                  hideSelectedOptions={false}
                  isCheckboxSelect={true}
                  isSearchable={true}
                  closeMenuOnSelect={false}
                  className={inputStyle}
                  placeholder={filter.placeholder}
                  options={[...(state[filter.option] || [])]
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map((option) => {
                      const isBlocked =
                        filter.type === "sprint" &&
                        selectedFilters["selectedProject"]?.length === 0;
                      return {
                        ...option,
                        isDisabled: isBlocked,
                      };
                    })}
                  onChange={(selectedFilter) => {
                    onFilterChange(selectedFilter, filter.type, filter.key);
                  }}
                  value={selectedFilters[filter.key]}
                />
              </div>
            );
          })}

          {/* Filter and Clear buttons stay with other filters */}
          <div className="filter-item button-filter">
            <ButtonComponent
              className="btn-apply"
              text="Filter"
              onClick={() => onFilterClick(selectedFilters)}
              disabled={isFilterDisabled || IsSprintSelect}
              data-testid="sbomFilter-btn"
            />
          </div>

          <div className="filter-item button-filter">
            <ButtonComponent
              className="filterCancel"
              text="Clear"
              variant="none"
              onClick={onClear}
              disabled={isCancelDisabled}
              data-testid="sbomClear-btn"
            />
          </div>

          {/* More Filter button pushed to the end */}
          <div className="more-filter-wrapper">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>More Filter</Tooltip>}
            >
              <div
                className={`more-filter-btn ${enableMoreFiler ? "" : FilterDisable
                  }`}
                onClick={enableMoreFiler ? MoreTypeFilter : undefined}
              >
                {MoreFilterText}
              </div>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </>
  );
};
DevOpsFilter.propTypes = {
  filterOptions: PropTypes.array,
  hideProjectDropdown: PropTypes.bool,
  hideSprintDropdown: PropTypes.bool,
  flowFilterClass: PropTypes.string,
  projectFilterUrl: PropTypes.string,
  inputStyle: PropTypes.string,
  MoreTypeFilterClick: PropTypes.func,
  dateInputStyle: PropTypes.string,
  MoreFilterText: PropTypes.any,
  getFilteredData: PropTypes.func,
  isNavigated: PropTypes.bool,
  FilterDisable: PropTypes.bool,
  enableMoreFiler: PropTypes.bool,
  setEnableMoreFilter: PropTypes.func,
  hideDateRangePickerClass: PropTypes.string,
};
export default DevOpsFilter;
